import { apiGet, apiPost, API_HOST, getToken } from './api';

export interface BotEmployee {
  id: number;
  botId: number;
  userId: number | null;
  userName: string | null;
  avatar: string | null;
  status: number | null;
  isLoggedIn: boolean;
  createTime: string;
}

export interface AvailableBot {
  id: number;
  userId: number | null;
  userName: string | null;
  avatar: string | null;
  status: number | null;
  isLoggedIn: boolean;
}

// ===== 专属机器人员工 =====

export async function getEmployeeList(): Promise<BotEmployee[]> {
  const res = await apiGet<{ code: number; data: BotEmployee[]; msg?: string }>('/api/bot-employee/list');
  if (res.code !== 0) throw new Error(res.msg || '获取员工列表失败');
  return res.data;
}

export async function addEmployee(botId: number): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/bot-employee/add', { botId });
  if (res.code !== 0) throw new Error(res.msg || '添加员工失败');
}

export async function removeEmployee(id: number): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/bot-employee/remove', { id });
  if (res.code !== 0) throw new Error(res.msg || '移除员工失败');
}

export async function updateNickname(id: number, nickname: string): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/bot-employee/update-nickname', { id, nickname });
  if (res.code !== 0) throw new Error(res.msg || '修改昵称失败');
}

export async function updateAvatar(id: number, avatar: string): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>('/api/bot-employee/update-avatar', { id, avatar });
  if (res.code !== 0) throw new Error(res.msg || '修改头像失败');
}

/**
 * 上传头像图片到 xmarsLive 对象存储；只返回 URL，不修改任何数据。
 * 调用方拿到 URL 做预览后，需另调 updateAvatar 才会真正生效。
 */
export async function uploadAvatarImage(id: number, file: File): Promise<string> {
  const form = new FormData();
  form.append('id', String(id));
  form.append('file', file);
  const token = getToken();
  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const resp = await fetch(`${API_HOST}/api/bot-employee/upload-avatar-image`, {
    method: 'POST',
    headers,
    body: form,
  });
  if (resp.status === 401) {
    localStorage.removeItem('billygo_token');
    localStorage.removeItem('billygo_user');
    window.location.href = '/login';
    throw new Error('登录已过期，请重新登录');
  }
  const json = await resp.json().catch(() => ({}));
  if (json.code !== 0) {
    throw new Error(json.msg || '上传头像失败');
  }
  return json.data?.url as string;
}

export async function searchAvailableBots(keyword?: string): Promise<AvailableBot[]> {
  const path = keyword ? `/api/bot-employee/search-available?keyword=${encodeURIComponent(keyword)}` : '/api/bot-employee/search-available';
  const res = await apiGet<{ code: number; data: AvailableBot[]; msg?: string }>(path);
  if (res.code !== 0) throw new Error(res.msg || '搜索机器人失败');
  return res.data;
}
